import {MenuItemActionBase} from "../menu-item-action-base";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {IMenuItemConfigReader} from "../../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface";
import {DialogButtonClickHandleResultEnum} from "../../dialog/dialog.service.interface";

export default class HybridInfoAction extends MenuItemActionBase {
    constructor(configReader: IMenuItemConfigReader, services: IServiceFactoryExtended) {
        super("hybridInfoMenuItem", configReader, services);
    }

    protected async _onClick(): Promise<void> {
        const hybridInfo = await this.services.hybrid.getInfoForDisplay();
        this.services.dialog.showSimpleTextModal({
            title: 'Info',
            text: hybridInfo,
            buttons: [
                {
                    text: 'Close',
                    buttonPreset: 'special',
                    onClick: async () => {
                        return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
                    }
                },
                {
                    text: 'Mail to',
                    buttonPreset: 'primary',
                    onClick: async () => {
                        this.services.hybrid.openMail(hybridInfo);
                        return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
                    }
                }
            ]
        })
        await this.services.orbitComponentInsideSdkProvider.showAboutDialog();
    }


}



